import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from "@angular/core";
import * as Highcharts from "highcharts";
import { Subject } from "rxjs";
declare let require;
const SolidGauge = require("highcharts/modules/solid-gauge");
const More = require("highcharts/highcharts-more");
More(Highcharts);
SolidGauge(Highcharts);

@Component({
  selector: "app-circular-progress",
  templateUrl: "./circular-progress.component.html",
  styleUrls: ["./circular-progress.component.scss"]
})
export class CircularProgressComponent implements OnInit,OnChanges,OnDestroy{
  @Input() id;
  @Input() data;
  @Input() chartColors: any[];
  @Input() yAxisLabelType: any;
  @Input() subtitle: any;
  @Input() backGroundColor;
  @Input() radius;
  private destroy$ = new Subject<void>();

  constructor() {}

  ngOnChanges(changes: SimpleChanges): void {
    this.drawCircularProgressChart();
  }

  ngOnInit(): void {
    this.drawCircularProgressChart();
  }
  public drawCircularProgressChart() {
    let yAxisType = this.yAxisLabelType;
    let total = this.data;
    if (this.yAxisLabelType == "percentage") {
      total = total + "%";
    }
    let subtitle = this.subtitle;
    Highcharts.setOptions({
      colors: this.chartColors,
    });
    const options: any = {
      chart: {
        type: "solidgauge",
        height: "180",
        events: {
          load: function () {
            const chart: any = this;
            if (this.grossLabel) {
              this.grossLabel.destroy();
            }
            const newX = chart.plotWidth / 2 + chart.plotLeft,
              newY = chart.plotHeight / 2 + chart.plotTop;
            this.grossLabel = chart.renderer
              .text(
                '<span style="font-size: 20px; font-weight: 600; font-family: var(--font-primary); color: #000000">' +
                  total +
                  "</span>" +
                  "<br/>" +
                  '<span style="font-size: 10px; font-weight: 500; color: #888;">' +
                  subtitle +
                  "</span>",
                newX,
                newY
              )
              .attr({
                align: "center",
              })
              .css({
                color: "#4572A7",
                fontSize: "12pt",
              })
              .add();
          },
          redraw: function () {
            const chart: any = this;
            if (this.grossLabel) {
              this.grossLabel.destroy();
            }
            const newX = chart.plotWidth / 2 + chart.plotLeft,
              newY = chart.plotHeight / 2 + chart.plotTop;
            this.grossLabel = chart.renderer
              .text(
                '<span style="font-size: 20px; font-weight: 600; font-family: var(--font-primary); color: #000000"">' +
                  total +
                  "<br/>" +
                  '<span style="font-size: 10px; font-weight: 500; color: #888;">' +
                  subtitle +
                  "</span>",
                newX,
                newY
              )
              .attr({
                align: "center",
              })
              .css({
                color: "#4572A7",
                fontSize: "12pt",
              })
              .add();
          },
        },
      },
      credits: {
        enabled: false,
      },
      title: {
        text: "",
        style: {
          fontSize: "20px",
        },
      },
      pane: {
        startAngle: 0,
        endAngle: 360,
        background: [
          {
            outerRadius: "112%",
            innerRadius: "95%",
            backgroundColor: this.backGroundColor,
          },
        ],
      },
      yAxis: {
        min: 0,
        max: 100,
        lineWidth: 0,
        tickPositions: [],
        labels: {
          formatter: function (event) {
            return yAxisType === "percentage"
              ? [this.value] + "%"
              : yAxisType === "dollar"
                ? "$" + [this.value]
                : [this.value];
          },
        },
      },
      plotOptions: {
        solidgauge: {
          dataLabels: {
            enabled: false,
          },
          linecap: "round",
          stickyTracking: false,
          rounded: true,
        },
      },
      tooltip: {
        enabled: false,
      },
      series: [
        {
          data: [
            {
              radius: this.radius ? this.radius :"110%",
              innerRadius: "95%",

              y: this.data,
            },
          ],
        },
      ],
    };
    Highcharts.chart(this.id, options);
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }
}
